import { QuickAddComponent } from '@theme/quick-add';

/**
 * Componente de botão "Comprar Agora" que estende o QuickAddComponent.
 * Diferente do quick-add original, lê a URL do produto de um data-attribute
 * em vez de depender de um product-card ancestral.
 */
class BuyNowComponent extends QuickAddComponent {
  get productPageUrl() {
    const baseUrl = this.dataset.productUrl || '';
    if (!baseUrl) return '';

    const url = new URL(baseUrl, window.location.origin);
    return url.toString();
  }
}

if (!customElements.get('buy-now-component')) {
  customElements.define('buy-now-component', BuyNowComponent);
}
